
export type InvoiceDimension = { name: string, value: string }

export enum CollectionMethod {
    charge_automatically = 'charge_automatically',
    send_invoice = 'send_invoice'
}

export type Invoice = {
    id: string,
    amountDue: number,
    amountPaid: number,
    currency: string,
    customerId: string,
    customerEmail: string,
    customerName: string,
    description: string,
    number: string,
    paid: boolean,
    periodStart: string,
    periodEnd: string,
    status: string,
    total: number,
    collectionMethod: CollectionMethod,
    daysUntilDue: number,
    hostedInvoiceUrl?: string
    invoicePdf?: string
    created: string,
    updated?: string,

    /**
     * FNP-918: `created` normalised to MILLISECONDS.
     *
     * Derived in useInvoices, not returned by the API. It exists so the
     * Created column can DISPLAY and SORT the same value: the old column
     * coerced and multiplied inline inside `render`
     * (`item.created as unknown as number * 1000`), which left nothing for a
     * sort accessor to point at.
     *
     * ⚠️ `created` is typed `string` above but Stripe returns epoch SECONDS.
     * The coercion is done once, in useInvoices, rather than at each reader.
     */
    createdAtMillis?: number,
}

// FNP-918: `IInvoiceTableColumn` lived here to type the hand-rolled
// <TableHeaderRow>/<TableBody> column array. That table is gone — columns are
// now `DataTableColumn<Invoice>[]` from mantine-datatable, declared in
// hooks/useInvoicesTableColumns.tsx — so the interface, and the ITableColumn /
// ReactNode imports it needed, went with it.


export type ListInvoices = {
    listInvoices: { items: Invoice[], nextToken?: string }
}

export type GetInvoice = {
    getInvoice: Invoice
}

export type CreateInvoice = {
    createInvoice: Invoice
}

export type UpdateInvoice = {
    updateInvoice: Invoice
}

export type DeleteInvoice = {
    deleteInvoice: string
}

export type SendInvoice = {
    sendInvoice: Invoice
}

export type VoidInvoice = {
    voidInvoice: Invoice
}